import React, { Fragment } from 'react'
import { CopyButton } from '../../../design-system'
import { logSuccess } from '../../toaster'
import { ContrastFormattedMessage } from '../../contrast-formatted-message'

export interface Props {
  readonly type: string
  readonly displayName: string
  readonly sourceIP?: string
  readonly sourceName?: string
  readonly copyButton?: boolean
}

export function TitleString({
  type,
  sourceIP,
  sourceName,
  displayName,
  copyButton
}) {
  const value = sourceName ? sourceName : sourceIP
  return type === 'PR' ? (
    <ContrastFormattedMessage
      id={
        !value
          ? 'variable_attackEventDetail_eventDescriptionUnknown'
          : 'variable_attackEventDetail_eventDescription'
      }
      values={
        !value
          ? { eventName: displayName }
          : { eventName: displayName, eventSource: value }
      }
      children={(msg) => (
        <Fragment>
          {msg}
          {copyButton && (
            <ContrastFormattedMessage
              id="detail_attacks_attackTitleSuccessfullyCopied"
              children={(successMessage) => (
                <div>
                  <CopyButton
                    stringToCopy={msg}
                    onClick={() => logSuccess(successMessage)}
                    buttonTranslationID="detail_attacks_clickToCopyAttackTitle"
                  />
                </div>
              )}
            />
          )}
        </Fragment>
      )}
    />
  ) : (
    <Fragment>{displayName}</Fragment>
  )
}
